export const Wrapper = 'flex flex-col xl:flex'

export const TableViewHeadWrapper = 'hidden w-full items-center pb-2 xl:flex'

export const TableViewArticleName = 'flex grow'

export const TableViewQuantity = 'w-full max-w-[90px] shrink-0 pr-1 text-right'

export const TableViewUnitPrice =
  'w-full max-w-[100px] shrink-0 pr-1 text-right'

export const TableViewProductStatus =
  'w-full max-w-[100px] shrink-0 pr-1 text-right'

export const TableViewTotal = 'w-full max-w-[100px] shrink-0 text-right'

export const ProductLineItemWrapper =
  'border-machine2-75 border-machine2-75 flex w-full flex-col border-b py-4 xl:flex-row xl:items-center'

export const ProductLineItemArticleWrapper =
  'flex w-full grow flex-col md:flex-row md:items-center'

export const ProductLineItemArticleImageWrapper =
  'mr-2 flex w-[100px] shrink-0 md:w-[80px]'

export const ProductLineItemArticleImageContainer = 'relative pt-[100%] w-full'

export const ProductLineItemArticleImage = 'absolute top-0 left-0'

export const ProductLineItemArticleDetailsWrapper =
  'flex w-full flex-col pt-2 md:pt-0'

export const ProductLineItemArticleName = ''

export const ProductLineItemArticleDescription = 'text-grayRegular'

export const ProductLineItemArticleNumber = 'text-grayRegular text-12 pt-1'

export const ProductLineItemTableQuantity =
  'hidden w-full max-w-[90px] shrink-0 pr-1 text-right xl:inline'

export const ProductLineItemTableUnitPrice =
  'hidden w-full max-w-[100px] shrink-0 pr-1 text-right xl:inline'

export const ProductLineItemTableProductStatus =
  'hidden w-full max-w-[100px] shrink-0 pr-1 text-right xl:inline'

export const ProductLineItemTableTotal =
  'hidden w-full max-w-[100px] shrink-0 flex-col text-right xl:flex'

export const ProductLineItemTableTotalBasePrice = 'text-mediumGray line-through'

export const ProductLineItemTableTotalPromoPrice = 'text-errorRed'

export const ProductLineItemQuantityStatusWrapper =
  'flex grow flex-col md:ml-2 md:pl-[80px]'

export const ProductLineItemStatusWrapper = 'w-full'

export const ProductLineItemQuantityWrapper = 'w-full pt-1'

export const ProductLineItemPriceInfoWrapper =
  'flex w-full max-w-[100px] shrink-0 flex-col text-right'

export const ProductLineItemDetailsWrapper = 'flex pt-1 xl:hidden'
